import gql from 'graphql-tag'
import { UpdateFloorInput, BMDialogFloor } from '@api'
import { BMDialogFloorFragment } from '@api/fragments'
import client from '@stores/apollo'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  updateFloor: { floor: BMDialogFloor }
}

const mutateHandler = handleFetchResult<IPayload, BMDialogFloor>({
  handler: (data) => data.updateFloor.floor,
  name: 'Dialog Floor',
})

export default function update(input: UpdateFloorInput): Promise<BMDialogFloor> {
  return client.gql.mutate({ mutation, variables: { input } }).then(mutateHandler)
}

const mutation = gql`
  mutation updateFloor($input: UpdateFloorInput!) {
    updateFloor(input: $input) {
      floor {
        ...BMDialogFloorFragment
      }
    }
  }
  ${BMDialogFloorFragment}
`
